
import io from 'socket.io-client';
import env from './environment';

let connectionID = null;
let connectionIDCallback = null;

class Socket {
  constructor() {
    this.connect = this.connect.bind(this);
    this.on = this.on.bind(this);
  }

  connect() {
    this.socket = io.connect(env.backendUrl, { secure: true });
    this.socket.on('connection_id', id => {
      if (connectionIDCallback) connectionIDCallback(id);
      else connectionID = id;
    });
  }

  on(event, callback) {
    this.socket.on(event, callback);
  }

  onConnectionID(callback) {
    if (connectionID) callback(connectionID);
    else connectionIDCallback = callback;
  }
}

export default new Socket();



// WEBPACK FOOTER //
// ./src/globals/socket.js